import {
  League as SharedLeague,
  LeagueStatus as SharedLeagueStatus,
  LEAGUE_STATUSES as SharedLeagueStatuses,
} from "shared/dist/types/League";

export type LeagueStatus = SharedLeagueStatus;
export const LEAGUE_STATUSES = SharedLeagueStatuses;


export default interface League extends SharedLeague {}